import { render, staticRenderFns } from "./CardRequisitionItems.vue?vue&type=template&id=78fa85d4&"
import script from "./CardRequisitionItems.vue?vue&type=script&lang=js&"
export * from "./CardRequisitionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports